var _rect, _rect2, _path, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E6E5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20.5,
    width: 30.9091,
    height: 40,
    rx: 4,
    fill: "white",
    stroke: "#8E8CEE",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4544 46.371C45.2446 46.371 49.9385 41.677 49.9385 35.8868C49.9385 30.0966 45.2446 25.4026 39.4544 25.4026C33.6641 25.4026 28.9702 30.0966 28.9702 35.8868C28.9702 41.677 33.6641 46.371 39.4544 46.371ZM35.2958 39.7026C35.6518 41.1366 36.2765 42.578 37.2447 43.98C34.9496 43.3548 33.0462 41.7794 31.9833 39.7026H35.2958ZM37.4697 39.7026C37.8492 40.9579 38.4855 42.2168 39.4544 43.4426C40.4232 42.2168 41.0596 40.9579 41.439 39.7026H37.4697ZM41.8478 37.6058H37.061C36.9707 36.638 37.0114 35.685 37.147 34.7643C37.1675 34.6252 37.1901 34.4868 37.2149 34.3492H41.6939C41.7186 34.4868 41.7413 34.6252 41.7618 34.7643C41.8974 35.685 41.938 36.638 41.8478 37.6058ZM43.6129 39.7026C43.2569 41.1366 42.6323 42.578 41.6641 43.98C43.9592 43.3548 45.8626 41.7794 46.9254 39.7026H43.6129ZM47.6654 37.6058H43.9515C44.0355 36.5328 43.9862 35.477 43.8362 34.4588C43.8308 34.4222 43.8253 34.3857 43.8197 34.3492H47.7011C47.7934 34.8477 47.8417 35.3616 47.8417 35.8868C47.8417 36.476 47.781 37.0509 47.6654 37.6058ZM34.9572 37.6058H31.2434C31.1278 37.0509 31.067 36.476 31.067 35.8868C31.067 35.3616 31.1153 34.8477 31.2077 34.3492H35.0891C35.0834 34.3857 35.0779 34.4222 35.0725 34.4588C34.9226 35.477 34.8733 36.5328 34.9572 37.6058ZM35.5607 32.2524H31.8933C32.9906 29.9735 35.0879 28.2669 37.616 27.7016C36.821 28.9764 36.0684 30.5293 35.5607 32.2524ZM39.4544 28.7166C38.8214 29.7164 38.2118 30.9212 37.76 32.2524H41.1487C40.697 30.9212 40.0873 29.7164 39.4544 28.7166ZM43.348 32.2524H47.0155C45.9181 29.9735 43.8209 28.2669 41.2928 27.7016C42.0878 28.9764 42.8404 30.5293 43.348 32.2524Z",
    fill: "#8E8CEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4546,
    y: 51.6173,
    width: 20,
    height: 1.81818,
    rx: 0.90909,
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.bf9288355ec1e6abdfe616660e2075d2.svg";
export { ForwardRef as ReactComponent };